"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBanner = void 0;
exports.ErrorPage = ErrorPage;
exports.SorryPage = SorryPage;
exports.UnsubscribePage = UnsubscribePage;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _toggleSubscription = _interopRequireDefault(require("./toggle-subscription"));
var _index = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _icon = require("@site/pattern-library-utils/icon");
var _traffic = require("@site/pattern-library-utils/traffic");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CTAContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CTAContainer",
  class: "pl-cwt0m9k"
});
const ErrorBanner = exports.ErrorBanner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ErrorBanner",
  class: "pl-enyt009"
});
const SuccessBanner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SuccessBanner",
  class: "pl-sv99n7"
});
function ErrorPage({
  errorMessage,
  iconType = 'alert'
}) {
  return /*#__PURE__*/_react.default.createElement(ErrorBanner, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: iconType
  })), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: 0,
    text: errorMessage
  }));
}
ErrorPage.propTypes = {
  errorMessage: _propTypes.default.string.isRequired,
  iconType: _propTypes.default.string
};
function UnsubscribePage({
  id,
  _name,
  title,
  successMessage,
  errorMessage,
  subscriptionTitle,
  subscriptionDescription,
  disclaimer,
  submitCtaText,
  cancelCtaText,
  consents,
  selectedConsents,
  handleToggleConsent,
  handleUpdateConsents,
  handleUnsubscribe,
  updating,
  error,
  success,
  handleToggleSubscription
}) {
  const [allToggled, setAllToggled] = (0, _react.useState)(selectedConsents.length > 0);
  const allConsentKeys = consents.map(consent => consent.consentKey);
  const handleToggle = () => {
    const newToggleState = !allToggled;
    setAllToggled(newToggleState);
    const newSelectedConsents = newToggleState ? allConsentKeys : [];
    if (handleToggleConsent) {
      handleToggleConsent(newSelectedConsents);
    }
    if (handleToggleSubscription) {
      handleToggleSubscription(newToggleState);
    }
  };
  const handleCancel = () => {
    if (typeof window !== 'undefined') {
      window.location.href = window.location.origin;
      (0, _traffic.logEvent)({
        eid: `gce.sales.subscription/unsubscribe.lists.cancel.button`,
        type: 'click'
      });
    }
  };
  const handleButtonClick = () => {
    if (handleUpdateConsents) {
      handleUpdateConsents();
    }
    if (handleUnsubscribe) {
      handleUnsubscribe();
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, title && /*#__PURE__*/_react.default.createElement(_text.default.h4, {
    as: "title",
    size: 5,
    text: title
  }), successMessage && success && /*#__PURE__*/_react.default.createElement(SuccessBanner, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "checkmark"
  })), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: 0,
    text: successMessage
  })), errorMessage && error && /*#__PURE__*/_react.default.createElement(ErrorPage, {
    errorMessage: errorMessage
  })), /*#__PURE__*/_react.default.createElement(_toggleSubscription.default, {
    displayName: subscriptionTitle,
    displayDescription: subscriptionDescription,
    checked: allToggled,
    onToggle: handleToggle
  }), disclaimer && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    text: disclaimer
  })), /*#__PURE__*/_react.default.createElement(CTAContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: [{
      id: `${id}-update-button`,
      _name: `${_name}-update-button`,
      text: submitCtaText,
      type: 'button',
      width: 'full',
      disabled: !allToggled || updating,
      onClick: handleButtonClick,
      dataCy: 'unsubscribe-button'
    }, {
      id: `${id}-cancel-button`,
      _name: `${_name}-cancel-button`,
      text: cancelCtaText,
      design: 'inline',
      width: 'full',
      onClick: handleCancel,
      dataCy: 'cancel-button'
    }]
  })));
}
UnsubscribePage.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  title: _propTypes.default.string,
  subscriptionTitle: _propTypes.default.string,
  subscriptionDescription: _propTypes.default.string,
  disclaimer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  submitCtaText: _propTypes.default.string,
  cancelCtaText: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  successMessage: _propTypes.default.string,
  consents: _propTypes.default.arrayOf(_propTypes.default.shape({
    consentKey: _propTypes.default.string.isRequired,
    value: _propTypes.default.bool.isRequired
  })).isRequired,
  selectedConsents: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  handleToggleConsent: _propTypes.default.func,
  handleUpdateConsents: _propTypes.default.func,
  handleUnsubscribe: _propTypes.default.func,
  handleToggleSubscription: _propTypes.default.func,
  updating: _propTypes.default.bool.isRequired,
  error: _propTypes.default.bool,
  success: _propTypes.default.bool
};
function SorryPage({
  id,
  _name,
  successMessage,
  errorMessage,
  success,
  error,
  sorryPageTitle,
  sorryPageDescription,
  sorryPageCtaText,
  sorryPageCtaUrl
}) {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_text.default.h4, {
    as: "title",
    size: 5,
    text: sorryPageTitle
  }), successMessage && success && /*#__PURE__*/_react.default.createElement(SuccessBanner, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "checkmark"
  })), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: 0,
    text: successMessage
  })), errorMessage && error && /*#__PURE__*/_react.default.createElement(ErrorPage, {
    errorMessage: errorMessage
  }), /*#__PURE__*/_react.default.createElement(_text.default.h4, {
    as: "paragraph",
    size: 0,
    text: sorryPageDescription
  }), /*#__PURE__*/_react.default.createElement(CTAContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: [{
      id: `${id}-preferences-button`,
      _name: `${_name}-preferences-button`,
      text: sorryPageCtaText,
      type: 'button',
      intent: 'primary',
      width: 'full',
      href: sorryPageCtaUrl
    }]
  })));
}
SorryPage.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  successMessage: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  success: _propTypes.default.bool,
  error: _propTypes.default.bool,
  sorryPageTitle: _propTypes.default.string.isRequired,
  sorryPageDescription: _propTypes.default.string,
  sorryPageCtaText: _propTypes.default.string.isRequired,
  sorryPageCtaUrl: _propTypes.default.string.isRequired
};